import { PATHS } from "@/internals/constants/paths";
import { QRSlugLandingPageEnum } from "@/types/types";
import { DomainRouteConfig } from "../types";

const semLandingPublicRoutes = Object.values(QRSlugLandingPageEnum);

const publicRoutes = [
  PATHS.HOME,
  PATHS.HOME_B,
  ...semLandingPublicRoutes,
  PATHS.LOGIN,
  PATHS.SIGNUP,
  PATHS.FORGOT_PASSWORD,
  PATHS.RESET_PASSWORD,
  PATHS.SET_PASSWORD,
  PATHS.TERMS_AND_CONDITIONS,
  PATHS.TERMS_OF_USE,
  PATHS.PRIVACY_POLICY,
  PATHS.COOKIES_POLICY,
  PATHS.IMPRESSUM,
  PATHS.ABOUT_US,
  PATHS.CONTACT_US,
  PATHS.HOW_WE_ARE,
  PATHS.PRICING,
  PATHS.FAQ,
  PATHS.VERIFY_PAYMENT,
  PATHS.INACTIVE,
  PATHS.WHOWEARE,
  PATHS.QR_EDITOR,
];

const initialPrefetchRoutes = [PATHS.HOME, PATHS.LOGIN, PATHS.SIGNUP, PATHS.PRICING];

export const SPECIAL_ROUTES = ["/qr/", "/p/"];

export const defaultConfig: DomainRouteConfig = {
  requiresAuth: false,
  homePath: PATHS.HOME,
  logoLinkEnabled: true,
  authRedirectPath: PATHS.HOME,
  logoutRedirectPath: PATHS.HOME,
  publicRoutes,
  initialPrefetchRoutes,
  paymentSsrEnabled: false,
  abTestConfig: {
    provider: "vwo",
    enabled: false,
    config: {},
  },
};

/** Shared by www and app while both hostnames serve the same product experience. */
const qrcreatorPublicAppConfig: DomainRouteConfig = {
  ...defaultConfig,
  initialPrefetchRoutes: [],
  abTestConfig: {
    provider: "vwo",
    enabled: true,
    config: {
      accountId: "116448",
    },
  },
  amplitudeWebExperimentsEnabled: true,
  paymentSsrEnabled: false,
};

export const domainConfigs: Record<string, DomainRouteConfig> = {
  localhost: defaultConfig,
  "fastqrgenerator.com": {
    ...defaultConfig,
    paymentSsrEnabled: true,
  },
  "app.qrnow.com": {
    requiresAuth: true,
    homePath: PATHS.MY_QR_CODES,
    logoLinkEnabled: false,
    authRedirectPath: PATHS.LOGIN,
    logoutRedirectPath: PATHS.LOGIN,
    publicRoutes: publicRoutes.filter((route) => route !== PATHS.QR_EDITOR),
    initialPrefetchRoutes,
    skipPendingActionForUnauth: true,
    paymentSsrEnabled: true,
  },
  "app.onlineqrcode.com": {
    requiresAuth: true,
    homePath: PATHS.QR_EDITOR,
    logoLinkEnabled: true,
    authRedirectPath: PATHS.QR_EDITOR,
    logoutRedirectPath: PATHS.QR_EDITOR,
    publicRoutes: [...publicRoutes, PATHS.QR_EDITOR],
    initialPrefetchRoutes,
    paymentSsrEnabled: true,
  },
  "qrcreator.com": qrcreatorPublicAppConfig,
  "app.qrcreator.com": qrcreatorPublicAppConfig,
};

export const authorisedBaseDomains: string[] = [
  "localhost",
  "fastqrgenerator.com",
  "qrnow.com",
  "onlineqrcode.com",
  "qrcreator.com",
];

export const getDomainConfig = (hostname: string): DomainRouteConfig => {
  const foundConfig = Object.entries(domainConfigs).find(([domain]) =>
    hostname.includes(domain)
  )?.[1];

  return foundConfig ?? defaultConfig;
};
